<template>
  <div id="login">
    <el-container class="page_login">
      <el-main>
        <!-- 登录卡片区域 -->
        <el-card class="box_card">
          <div class="el-card__body card_content">
            <div class="content_left"></div>
            <div class="content_right">
              <!-- 右侧上部 -->
              <div class="content_right_top"></div>
              <!-- 右侧下部表单区域 -->
              <el-form class="form_login" :model="ruleForm" :rules="formRiles">
                <el-form-item class="form_select" prop="region">
                  <el-select
                    class="form_select_select"
                    v-model="ruleForm.region"
                    placeholder="请选择你的身份"
                  >
                    <el-option label="学校管理员" value="school"></el-option>
                    <el-option label="教师" value="teacher"></el-option>
                    <!-- <el-option label="学生" value="student"></el-option> -->
                  </el-select>
                </el-form-item>
                <el-form-item prop="name">
                  <el-input
                    name="account"
                    v-model.trim="ruleForm.name"
                    placeholder="请输入用户名"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input
                    v-model.trim="ruleForm.password"
                    type="password"
                    placeholder="请输入密码"
                    show-password
                  ></el-input>
                </el-form-item>
                <div class="wanji" @click="goForget">忘记密码?</div>
                <el-button type="primary" @click="formHandler">登录</el-button>
              </el-form>
            </div>
          </div>
        </el-card>
      </el-main>
      <el-footer>
        <foo-ter></foo-ter>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import fooTer from '../footer/footer'
import { userlogin } from '@/api/home'
export default {
  components: {
    fooTer,
  },
  data() {
    return {
      // 表单输入值
      ruleForm: {
        region: '',
        name: '',
        password: '',
      },
      //   token
      token: '',
      //   表单验证
      formRiles: {
        region: [{ required: true, message: '请选择角色', trigger: 'change' }],
        name: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
    }
  },
  methods: {
    async formHandler() {
      try {
        const { data: res } = await userlogin({
          roleType: this.ruleForm.region,
          account: this.ruleForm.name,
          password: this.ruleForm.password,
        })
        // 登录为学生的时跳转
        if (this.ruleForm.roleType == 'student') {
          window.location.href = 'http://live.welaiedu.cn/#/?token=' + res.token
        }
        // 跳转到工作台
        this.$router.push('/?token=' + res.data.token + '&roleId=-1004')
      } catch (err) {
        console.log(err)
      }
    },
    enters() {
      console.log(enters)
    },
    goForget() {
      this.$router.push('/forget')
    },
  },
}
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
}
#login {
  /* background-color: red; */

  height: 969px;
  width: 100%;
}

.page_login {
  background-color: #f0f2f5;
  width: 100%;
  height: 100vh;
}

.el-main {
  background-image: url('../../assets/img/login/bg_image.a7a1ba61.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  page-break-after: auto;
  position: relative;
}

/* 卡片区域样式 */

.box_card {
  width: 1080px;
  height: 592px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 20px;
  z-index: 99;
}

.card_content {
  width: 1040px;
  height: 552px;
  padding-top: 35px;
  border-radius: 10px;
  /* background-color:red; */
  display: flex;
  justify-content: space-between;
}

.card_content .content_left {
  width: 525px;
  height: 490px;
  background: #fff url('../../assets/img/login/left_image.e43f246f.png')
    no-repeat 100% 100%;
}

.card_content .content_right {
  width: 400px;
  height: 490px;
  border: 1px solid #dcdfe6;
}

.content_right_top {
  height: 80px;
  background: #fff url('../../assets/img/login/right-top-text.png');
}

.content_right .form_login {
  margin: 20px;
}

.el-scrollbar__view {
  padding: 10px;
}

.form_select {
  width: 100%;
}

.form_select_select {
  width: 360px;
}

.el-select-dropdown__item {
  padding-left: 10px;
  width: 360px;
}

.form_login .el-form-item {
  margin-top: 40px;
}

.el-button {
  width: 100%;
  height: 40px;
  border-radius: 20px;
  margin-top: 40px;
}

.wanji {
  font-size: 12px;
  margin-top: 10px;
  color: #dcdfed;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/login/Login.vue